import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    minHeight: '100vh',
    background: '#fff',
    display: 'flex',
    justifyContent: 'center',
    padding: 16,
    fontFamily: 'Nunito, Poppins, Sansation, sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: 360,
    background: '#fff',
    borderRadius: 30,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    position: 'relative',
    padding: '40px 20px 26px',
    '@media (max-width: 768px)': {
      borderRadius: 0,
      boxShadow: 'none',
      minHeight: '100vh',
    },
  },
  back: {
    position: 'absolute',
    top: 16,
    left: 16,
    border: 'none',
    background: 'transparent',
    color: '#C084FC',
    fontFamily: 'Poppins',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  title: {
    color: '#C084FC',
    fontSize: 28,
    fontFamily: 'Poppins',
    fontWeight: 700,
    marginTop: 34,
  },
  optionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginTop: 20,
    cursor: 'pointer',
  },
  radio: {
    width: 16,
    height: 16,
    borderRadius: 8,
    border: '2px solid #C084FC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    background: '#C084FC',
  },
  optionText: {
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 500,
    color: '#262626',
  },
  button: {
    width: '100%',
    height: 51,
    marginTop: 34,
    background: 'linear-gradient(90deg, #C084FC 0%, #724F96 100%)',
    boxShadow: '0px 9px 14px rgba(192, 132, 252, 0.20)',
    borderRadius: 10.4,
    border: 'none',
    color: 'white',
    fontSize: 18,
    fontFamily: 'Nunito',
    fontWeight: 700,
    cursor: 'pointer',
    opacity: 1,
  },
  buttonDisabled: {
    opacity: 0.45,
    cursor: 'not-allowed',
  },
}));

export default function SignupAs() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [value, setValue] = useState('property_owner');

  const options = useMemo(() => ([
    { id: 'property_owner', label: 'Property Owner' },
    { id: 'event_organizer', label: 'Event Organizer' },
    { id: 'valet_service', label: 'Valet Service Provider' },
  ]), []);

  const handleContinue = () => {
    if (value === 'property_owner') navigate('/property-information');
    else if (value === 'event_organizer') navigate('/event-organizer/signup');
    else if (value === 'valet_service') navigate('/valet-service/signup');
  };

  return (
    <div className={classes.root}>
      <div className={classes.card}>
        <button className={classes.back} onClick={() => navigate('/associates-login')}>
          <span style={{ fontSize: 22, lineHeight: 0 }}>←</span> Back
        </button>

        <Typography className={classes.title}>Sign up as:</Typography>

        {options.map((opt) => {
          const selected = value === opt.id;
          return (
            <div key={opt.id} className={classes.optionRow} onClick={() => setValue(opt.id)}>
              <div className={classes.radio}>
                {selected ? <div className={classes.dot} /> : null}
              </div>
              <div className={classes.optionText}>{opt.label}</div>
            </div>
          );
        })}

        <button
          className={`${classes.button} ${!value ? classes.buttonDisabled : ''}`}
          onClick={handleContinue}
          disabled={!value}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

